'use client'
import React, { useState } from 'react'

export default function Pagination2({ totalPages = 4, currentPage, onChange }) {
  const handlePageClick = (pageNumber) => {
    onChange?.(pageNumber)
  }

  const handlePrevClick = () => {
    if (currentPage > 1) {
      onChange(currentPage - 1)
    }
  }

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onChange(currentPage + 1)
    }
  }

  return (
    <nav
      className={`shop-pages d-flex ${totalPages > 1 ? `justify-content-between` : `justify-content-center`} mt-3`}
      aria-label="Page navigation"
    >
      {totalPages > 1 && (
        <a
          href="#"
          className={`btn-link d-inline-flex align-items-center ${
            currentPage === 1 ? 'disabled' : ''
          }`}
          onClick={(e) => {
            e.preventDefault()
            handlePrevClick()
          }}
        >
          <svg
            className="me-1"
            width="7"
            height="11"
            viewBox="0 0 7 11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_prev_sm" />
          </svg>
          <span className="fw-medium">上一頁</span>
        </a>
      )}

      <ul className="pagination mb-0">
        {Array.from({ length: totalPages }, (_, index) => (
          <li key={index} className="page-item">
            <a
              className={`btn-link px-1 mx-2 ${
                currentPage === index + 1 ? 'btn-link_active' : ''
              }`}
              href="#"
              onClick={(e) => {
                e.preventDefault()
                handlePageClick(index + 1)
              }}
            >
              {index + 1}
            </a>
          </li>
        ))}
      </ul>
      {totalPages > 1 && (
        <a
          href="#"
          className={`btn-link d-inline-flex align-items-center ${
            currentPage === totalPages ? 'disabled' : ''
          }`}
          onClick={(e) => {
            e.preventDefault()
            handleNextClick()
          }}
        >
          <span className="fw-medium me-1">下一頁</span>
          <svg
            width="7"
            height="11"
            viewBox="0 0 7 11"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use href="#icon_next_sm" />
          </svg>
        </a>
      )}
    </nav>
  )
}
